const dev = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
};

const prod = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
};

const test = {
  // API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  WEBSITE_ENDPOINT_URL: "https://www.capmas.gov.eg",
  CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/api",
  // CHATBOT_URL: "https://capmas-chatbot.digitalhub.com.eg/apiv2",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
